<template>
	<transition name="modal">
        <div class="modal-mask" @click="close" v-if="show">
            <div class="modal-container" :class="type" @click.stop>
              <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
	props: ['show','type'],
	methods: {
		close() {
			this.$emit('close');
		},
		keydown(e){
			if (this.show && e.keyCode == 27) {
				this.close();
			}
		}
	},
	mounted() {
		document.addEventListener('keydown', this.keydown);
	},
	destroyed(){
		document.removeEventListener('keydown', this.keydown);
	}
};
</script>
